import img1 from "../../Assets/images/bidImg.webp";
import img2 from "../../Assets/images/productimg2.webp";
import img3 from "../../Assets/images/productimg3.webp";
import img4 from "../../Assets/images/productimg5.webp";
import img5 from "../../Assets/images/productimg6.webp";
import creator1 from "../../Assets/images/creator1.png";
import creator2 from "../../Assets/images/creator2.png";

const Data = [
  {
    id: 1,
    mainImg: img1,
    artName: "Sally Fadel",
    ETH: 161,
    inStock: 5,
    highestBid: 6,
    bidType: "new bid",
    creator: [creator1],
  },
  {
    id: 2,
    mainImg: img2,
    artName: "Sally Fadel",
    ETH: 161,
    inStock: 5,
    highestBid: 6,
    bidType: "new bid",
    creator: [creator1, creator2],
  },
  {
    id: 3,
    mainImg: img3,
    artName: "Sally Fadel",
    ETH: 161,
    inStock: 5,
    highestBid: 6,
    bidType: "new bid",
    creator: [creator1, creator2, creator1],
  },
  {
    id: 4,
    mainImg: img4,
    artName: "Sally Fadel",
    ETH: 161,
    inStock: 5,
    highestBid: 6,
    bidType: "new bid",
    creator: [creator2],
  },
  {
    id: 5,
    mainImg: img5,
    artName: "Sally Fadel",
    ETH: 161,
    inStock: 5,
    highestBid: 6,
    bidType: "new bid",
    creator: [creator1],
  },
  {
    id: 6,
    mainImg: img3,
    artName: "Sally Fadel",
    ETH: 161,
    inStock: 5,
    highestBid: 6,
    bidType: "new bid",
    creator: [creator1, creator2, creator1],
  },
  {
    id: 7,
    mainImg: img4,
    artName: "Sally Fadel",
    ETH: 161,
    inStock: 5,
    highestBid: 6,
    bidType: "new bid",
    creator: [creator2],
  },
  {
    id: 8,
    mainImg: img5,
    artName: "Sally Fadel",
    ETH: 161,
    inStock: 5,
    highestBid: 6,
    bidType: "new bid",
    creator: [creator1],
  },
];

export default Data;
